<template>
    <FilterMultiSelect
        :selections="value"
        placeholder="Select Timezone(s)"
        :options="Timezones"
        @handleSelection="$emit('handleValueChange', $event)"
    />
</template>

<script>
import FilterMultiSelect from '@/components/common/FilterMultiSelect.vue';
import { Timezones } from '@/store/constants';

export default {
    name: 'TimezoneRule',
    props: ['value'],
    components: { FilterMultiSelect },
    data() {
        return {
            Timezones: Timezones,
        };
    },
};
</script>

<style scoped></style>
